import { FC } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { EditGuestlistBlockForm } from "Bands/containers";
import { eventBlockSelectorCreator, dataMetaSelector } from "Bands/state";
import { BAND_ACTIONS, EventBlocks, IGuestlistBlock } from "Bands/types";
import { FourOhThree, FourOhFour } from "shared/pages";
import { IAPIState } from "shared/types";
import { mapUserPermissions } from "shared/utils";

export const EditGuestlistBlockPage: FC = () => {
  const { blockId } = useParams<{ blockId: string }>();

  const guestlistBlockSelector = eventBlockSelectorCreator(blockId, EventBlocks.guestlist);
  const guestlistBlock = useSelector(guestlistBlockSelector) as IGuestlistBlock;

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.getEventGuestlistBlocks));

  if (guestlistBlock && !mapUserPermissions(guestlistBlock.permissions || []).EDIT) {
    return <FourOhThree />;
  }

  if (apiMeta?.status !== IAPIState.pending && !guestlistBlock) return <FourOhFour />;

  if (!guestlistBlock) return null;

  return <EditGuestlistBlockForm block={guestlistBlock} />;
};
